// extracted by mini-css-extract-plugin
module.exports = {"title":"_7a3fb80146--title--LDQrP","labels":"_7a3fb80146--labels--ek1ZQ"};